const COLORS = {
  primary: "#00166A",
  secondary: "#000A50",
  dark: "#000107",
  light: "#F6F6F6",
  grey: "#DADADA",
  link: "#0265d2",
};

export { COLORS };
